// extracted by mini-css-extract-plugin
export var language_picker = "FooterNavigation-module--language_picker--b1552";
export var logo = "FooterNavigation-module--logo--0fbde";
export var page_grid = "FooterNavigation-module--page_grid--24913";
export var section = "FooterNavigation-module--section--b4091";
export var social_networks = "FooterNavigation-module--social_networks--94604";
export var social_section = "FooterNavigation-module--social_section--a6eb0";